import React, { useEffect, useRef } from "react";
import s from './MyLoading.module.css';
import loading from'../../asset/loading.gif';

export function MyLoading() {
	
	return (<div>
		<div className={s.imageHolder}>
			<img className={s.imageActual} src={loading} />
		</div>
	
		<div className={s.modalBackdrop}/>
	</div>)
}

